module.exports = __webpack_public_path__ + "media/feature/problem_solving-6f207993.jpg";